import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-1 text-base justify-center items-center self-stretch py-6 px-4 mx-auto text-violet-600 rounded-md w-full max-w-full",
    style: _normalizeStyle({
      backgroundColor: _ctx.backgroundColor,
      fontFamily: _ctx.fontFamily,
      color: _ctx.textColor,
      fontWeight: _ctx.boldness,
    })
  }, [
    _createElementVNode("h1", {
      class: "text-center break-words overflow-hidden text-ellipsis max-w-full whitespace-normal",
      style: _normalizeStyle({
        fontSize: _ctx.headerFontSize ? `${_ctx.headerFontSize}px` : '',
        marginBottom: _ctx.headerMarginBottom,
        lineHeight: _ctx.headerLineHeight,
        wordWrap: 'break-word',
        hyphens: 'auto',
        fontFamily: _ctx.headerFontFamily,
      })
    }, _toDisplayString(_ctx.headlineText), 5),
    _createElementVNode("p", {
      class: "text-center break-words overflow-hidden text-ellipsis max-w-full whitespace-normal",
      style: _normalizeStyle({
        lineHeight: '1.5',
        fontSize: _ctx.paragraphFontSize ? `${_ctx.paragraphFontSize}px` : '',
        fontFamily: _ctx.headerFontFamily,
      })
    }, _toDisplayString(_ctx.paragraphText), 5)
  ], 4))
}